export const fieldLabels = {
  subject: "Subject",
  description: "Description",
  confidenceId: "Confidence Level",
  valenceId: "Flag or Mitigation",
  intelligenceSourceId: "Source",
  submissionOrganisations: "Awarding Organisations",
  submissionLinks: "Link(s)",
  submissionSources: "Source(s)",
  submissionRiskTypes: "Risk Types",
  resourceTags: "Tag(s)"
};